import { render } from "./welHome.vue?vue&type=template&id=69cf5f5f&scoped=true"
import script from "./welHome.vue?vue&type=script&lang=js"
export * from "./welHome.vue?vue&type=script&lang=js"

import "./welHome.vue?vue&type=style&index=0&id=69cf5f5f&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cf5f5f"]])

export default __exports__